import { render, staticRenderFns } from "./FacebookRemotePage.vue?vue&type=template&id=f3214bc6&"
import script from "./FacebookRemotePage.vue?vue&type=script&lang=js&"
export * from "./FacebookRemotePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports